import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { mfgApi } from './mfgApi';

const STORAGE_KEY = 'mfg_active_department'; // UI preference only — no sensitive data
const DepartmentContext = createContext(null);

export function DepartmentProvider({ children }) {
  const [departments, setDepartments] = useState([]);
  const [activeId, setActiveId] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || null; } catch { return null; }
  });
  const [loading, setLoading] = useState(true);
  // A8 · 現場ユーザーは自分の製造部門に固定（サーバー側でも強制される）
  const [locked, setLocked] = useState(false);
  const [myDeptId, setMyDeptId] = useState(null);

  const reload = useCallback(() => {
    setLoading(true);
    Promise.all([
      mfgApi.departments().then((d) => (Array.isArray(d) ? d : [])).catch(() => []),
      mfgApi.myDepartment().catch(() => ({ locked: false, department_id: null })),
    ])
      .then(([list, mine]) => {
        setDepartments(list);
        setLocked(!!mine.locked);
        setMyDeptId(mine.department_id || null);
        if (mine.locked) {
          setActiveId(mine.department_id || null);
        } else {
          setActiveId((cur) => cur || mine.department_id || null);
        }
      })
      .finally(() => setLoading(false));
  }, []);
  useEffect(() => { reload(); }, [reload]);

  const setActive = useCallback((id) => {
    if (locked) return;
    try {
      if (id) localStorage.setItem(STORAGE_KEY, id);
      else localStorage.removeItem(STORAGE_KEY);
    } catch { /* ignore */ }
    setActiveId(id);
  }, [locked]);

  const active = activeId && activeId !== 'all'
    ? departments.find((d) => d.id === activeId) || null
    : null;
  const isAll = activeId === 'all';

  return (
    <DepartmentContext.Provider value={{ departments, activeId, active, isAll, loading, setActive, reload, locked, myDeptId }}>
      {children}
    </DepartmentContext.Provider>
  );
}

export const useDepartment = () => useContext(DepartmentContext) || {
  departments: [], activeId: null, active: null, isAll: false, loading: true,
  setActive: () => {}, reload: () => {}, locked: false, myDeptId: null,
};
